const gameState = {
    home: [ [], [], [], [] ],
    slots: [ null, null, null, null ],
    laid: [ [], [], [], [], [], [], [], [] ]
};

export default gameState;